import { Alert } from '@mui/material';
import { useKeycloak } from '@react-keycloak/web';
import { Fragment, useCallback, useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { translate } from 'react-switch-lang';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import { DeleteButtonIcon } from 'src/component/Buttons/DeleteButtonIcon';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../../../security/hooks/axiosProvider';
import Breadcrumb from '../../../../breadcrumb';
import styles from '../../../../styles/style-setting.module.scss';
import CreateVillage from '../create-village/create-village';
import EditVillage from '../edit-village/edit-village';
import ActivityColumns from './table-header/village-columns';

// number of activities per page
const NUMBER_OF_VILLAGES_PER_PAGE = 15;

const ListVillagesPage = (props) => {
  const [selectedCountry, setSelectedCountry] = useState('');
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState('');
  const [departements, setDepartements] = useState([]);
  const [selectedDepartement, setSelectedDepartement] = useState('');
  const [communes, setCommunes] = useState([]);
  const [selectedCommune, setSelectedCommune] = useState('');
  const [villages, setVillages] = useState([]);
  const httpClient = useHttpClient(true);
  const [pageNumber, setPageNumber] = useState(0);
  const activityPerPage = NUMBER_OF_VILLAGES_PER_PAGE;
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };
  const keycloak = useKeycloak().keycloak;
  const [role, setRole] = useState('');
  const [search, setSearch] = useState('');
  const [data, setData] = useState([]);

  const [spinner, setSpinner] = useState({ state: false, id: '' });
  const pageCount = Math.ceil(
    (search === '' ? villages : villages.filter((village) => village.name.includes(search))).length / activityPerPage
  );
  const fetchCountries = () => {
    httpClient.current?.get(`/api/country/all`).then((response) => {
      setCountries(response.data);
    });
  };
  useEffect(() => {
    if (selectedCountry !== '') {
      httpClient.current?.get(`/api/region/all`).then((response) => {
        const regions = response.data.filter((region) => region.country.id == selectedCountry);
        setRegions(regions);
      });
    }
  }, [selectedCountry]);
  useEffect(() => {
    if (selectedRegion !== '') {
      httpClient.current?.get(`/api/departement/all`).then((response) => {
        const departements = response.data.filter((departement) => departement.region.id == selectedRegion);
        setDepartements(departements);
      });
    }
  }, [selectedRegion]);
  useEffect(() => {
    if (selectedDepartement !== '') {
      httpClient.current?.get(`/api/commune/all`).then((response) => {
        const communes = response.data.filter((commune) => commune.departement.id == selectedDepartement);
        setCommunes(communes);
      });
    }
  }, [selectedDepartement]);
  useEffect(() => {
    if (selectedCountry !== '') {
      getVillages(selectedCountry, selectedRegion, selectedDepartement, selectedCommune);
    } else {
      getVillages();
    }
  }, [selectedRegion, selectedCountry, selectedDepartement, selectedCommune, pageNumber]);

  const getVillages = useCallback(
    (selectedCountry = '', selectedRegion = '', selectedDepartement = '', selectedCommune = '') => {
      httpClient.current?.get(`/api/village/all`).then((response) => {
        setVillages(response.data);
        console.log(response.data);
        buildData(response.data, search, selectedCountry, selectedRegion, selectedDepartement, selectedCommune);
      });
    },
    [httpClient]
  );

  const buildData = (
    newCountries,
    searchCriteria,
    countryCriteria,
    regionCriteria,
    departementCriteria,
    communeCriteria
  ) => {
    const pagesVisited = pageNumber * NUMBER_OF_VILLAGES_PER_PAGE;
    const searchFilter = newCountries.filter((activity) =>
      activity.name.toUpperCase().includes(searchCriteria.toUpperCase())
    );
    let FILTERED =
      countryCriteria === ''
        ? searchFilter
        : searchFilter.filter((activity) => activity.commune.departement.region.country.id == countryCriteria);
    FILTERED =
      regionCriteria === ''
        ? FILTERED
        : FILTERED.filter((activity) => activity.commune.departement.region.id == regionCriteria);
    FILTERED =
      departementCriteria === ''
        ? FILTERED
        : FILTERED.filter((activity) => activity.commune.departement.id == departementCriteria);
    FILTERED =
      communeCriteria === '' ? FILTERED : FILTERED.filter((activity) => activity.commune.id == communeCriteria);
    const restPagination = FILTERED.slice(pagesVisited, pagesVisited + activityPerPage);

    const newData = restPagination.map((village) => {
      let action = (
        <div>
          <span>
            <EditVillage village={village} villages={getVillages} />
          </span>
          <span>
            <DeleteButtonIcon
              title={props.t('delete_village')}
              onClick={() =>
                SweetAlert.fire({
                  title: props.t('you_delete'),
                  text: props.t('not_recover'),
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: props.t('cancel'),
                  reverseButtons: true,
                }).then((result) => {
                  if (result.value) {
                    deleteVillage(village.id);
                    SweetAlert.fire(props.t('Deleted!'), props.t('isDeleted'), 'success');
                  } else {
                    SweetAlert.fire(props.t('isNotDeleted'));
                  }
                })
              }
              className={`fa fa-trash ${styles['trash']}`}
            />
          </span>
        </div>
      );
      let status =
        spinner.state === true && spinner.id === village.id ? (
          <div className={`loader-box  ${styles['spinner']}`}>
            <div className="loader-2"></div>
          </div>
        ) : (
          <input
            type="checkbox"
            disabled={role === 'admin'}
            name="status"
            checked={village?.valid}
            onChange={(e) => handleCheckBox(e, village)}
          />
        );

      return {
        id: village.id,
        name: village.name,
        code: village.code,
        status: status,
        action: action,
      };
    });
    setData(newData);
  };

  const deleteVillage = async (villageId) => {
    await httpClient.current?.delete(`/api/village/${villageId}`);
    getVillages();
  };

  const handleCheckBox = async (event, activity) => {
    setSpinner({ state: true, id: activity.id });
    const activityValidation = { id: activity.id, name: activity.name, valid: event.target.checked };
    const response = httpClient.current?.put(`/api/village/update`, activityValidation);
    if ((await response).status === 200) {
      getVillages();
      setSpinner({ state: false, id: activity.id });
    }
  };

  useEffect(() => {
    getVillages();

    if (keycloak.authenticated) {
      keycloak.hasResourceRole('ROLE_AGRISED_ADMIN_SUPER')
        ? setRole('super admin')
        : keycloak.hasResourceRole('ROLE_AGRISED_ADMIN')
        ? setRole('admin')
        : setRole('user');
    }
    fetchCountries();
  }, [getVillages, keycloak]);

  const handleSearch = (event) => {
    setSearch(event.target.value);
    buildData(villages, event.target.value, selectedCountry, selectedRegion, selectedDepartement, selectedCommune);
    changePage({ selected: 0 });
  };

  useEffect(() => {
    setPageNumber(0);
  }, [selectedCountry, selectedRegion, selectedDepartement, selectedCommune]);

  useEffect(() => {
    buildData(villages, search, selectedCountry, selectedRegion, selectedDepartement, selectedCommune);
  }, [villages, search, selectedCountry, selectedRegion, selectedDepartement, selectedCommune, pageNumber]);

  return (
    <div>
      <Fragment>
        <Breadcrumb parent={props.t('village_url')} url={'settings/village'} />
        <Container fluid={true}>
          <Row>
            <Col sm="12">
              <Card>
                <CardHeader>
                  <div className="float-right">
                    <CreateVillage villages={getVillages} allVillages={villages} />
                  </div>
                </CardHeader>
                <CardBody>
                  <div className="d-flex mb-2">
                    <input
                      className="form-control col-md-6 mr-2 "
                      onChange={handleSearch}
                      value={search}
                      placeholder={props.t('search_unit')}
                    />
                    <div className="flex-grow-1">
                      <select
                        className="form-control col-md-6 mb-2"
                        value={selectedCountry}
                        onChange={(event) =>
                          selectedRegion && selectedCountry == ''
                            ? setSelectedRegion('')
                            : setSelectedCountry(event.target.value)
                        }
                      >
                        <option value="">{props.t('all_countries')}</option>
                        {countries.map((country) => (
                          <option key={country.id} value={country.id}>
                            {country.name}
                          </option>
                        ))}
                      </select>
                      {selectedCountry !== '' && (
                        <select
                          className="form-control col-md-6 mb-2"
                          value={selectedRegion}
                          onChange={(event) => {
                            selectedDepartement && selectedRegion == ''
                              ? setSelectedDepartement('')
                              : setSelectedRegion(event.target.value);
                          }}
                        >
                          <option value="">{props.t('all_regions')}</option>
                          {regions.map((region) => (
                            <option key={region.id} value={region.id}>
                              {region.name}
                            </option>
                          ))}
                        </select>
                      )}
                      {selectedRegion !== '' && (
                        <select
                          className="form-control col-md-6 mb-2"
                          value={selectedDepartement}
                          onChange={(event) => {
                            selectedCommune && selectedDepartement == ''
                              ? setSelectedCommune('')
                              : setSelectedDepartement(event.target.value);
                          }}
                        >
                          <option value="">{props.t('all_departments')}</option>
                          {departements.map((departement) => (
                            <option key={departement.id} value={departement.id}>
                              {departement.name}
                            </option>
                          ))}
                        </select>
                      )}
                      {selectedDepartement !== '' && (
                        <select
                          className="form-control col-md-6 mb-2"
                          value={selectedCommune}
                          onChange={(event) => setSelectedCommune(event.target.value)}
                        >
                          <option value="">{props.t('all_communes')}</option>
                          {communes.map((commune) => (
                            <option key={commune.id} value={commune.id}>
                              {commune.name}
                            </option>
                          ))}
                        </select>
                      )}
                    </div>
                  </div>
                  {data.length === 0 ? (
                    <Alert variant="outlined" severity="info">
                      {props.t('no_village')}
                    </Alert>
                  ) : (
                    <ActivityColumns data={data} />
                  )}
                  <br />
                  <div className="float-right">
                    {villages.length > NUMBER_OF_VILLAGES_PER_PAGE && (
                      <ReactPaginate
                        previousLabel="<"
                        nextLabel=">"
                        pageCount={pageCount}
                        onPageChange={changePage}
                        containerClassName={styles['paginationButton']}
                        previousLinkClassName={styles['previousBtn']}
                        nextLinkClassName={styles['nextBtn']}
                        disabledClassName={styles['paginationDisabled']}
                        activeClassName={styles['paginationActive']}
                      />
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Fragment>
    </div>
  );
};
export default translate(ListVillagesPage);
